import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useForm, Controller } from 'react-hook-form';
import { Card, Button } from '@mui/material';
import { useParams } from 'react-router';
import PropTypes from 'prop-types';
import * as actions from '../../redux/actions';
import { BackButton } from '../../components/Button';
import { ContainerForm } from '../../components/Forms';
import { Loading } from '../../components/Loading';
import { Error } from '../../components/Error';
import { ViewTitle } from '../../components/ViewTitle';

export default function EditContainer({ title, subtitle }) {
  const dispatch = useDispatch();
  const { id } = useParams();
  const container = useSelector((state) => state.container);
  const {
    formState: { errors },
    handleSubmit,
    control,
  } = useForm({
    defaultValues: {
      licence_number: container.licence_number,
      description: container.description,
    },
  });

  useEffect(() => {
    dispatch(actions.containerGet(id));
    return () => {};
  }, []);

  console.log('id', id);

  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;

  const onSubmit = async (data) => {
    try {
      await dispatch(actions.containerPut(id, data));
      await dispatch(actions.containerGet(id));
      alert('สำเร็จ');
    } catch (error) {
      console.log(error);
    }
  };

  if (container.isLoading || container.rows) {
    return <Loading />;
  }
  if (!container.isLoading && container.isCompleted) {
    return (
      <div>
        {renderTitle()}
        <div className="flex flex-row justify-start pb-4">
          <div>
            <BackButton />
          </div>
        </div>
        <div>
          <Card className="p-4">
            <form onSubmit={handleSubmit(onSubmit)}>
              <ContainerForm
                errors={errors}
                container={container}
                control={control}
                Controller={Controller}
              />
              <div className="flex flex-row justify-end gap-1 py-4">
                <Button variant="contained" type="submit">
                  บันทึก
                </Button>
              </div>
            </form>
          </Card>
        </div>
      </div>
    );
  }
  return <Error />;
}
EditContainer.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

EditContainer.defaultProps = {
  title: '',
  subtitle: '',
};
